/* eslint-disable @typescript-eslint/no-unused-vars */
import { debounce, entries, flatMap, fromPairs, map } from 'lodash';
import { Dispatch } from 'redux';
import i18next from 'src/i18n/config';
import { login_action_types, USER_LOGOUT, USER_SWITCH } from './reduxConstants';
import { close_toast, show_toast } from './message';
import types from 'src/utils/types';
import { delete_persisted_data, save_persisted_data } from './persistedUserData';
import { PERSIST_REDUX_PATHS } from 'src/reducers/persistedUserData';
import * as Sentry from '@sentry/react';
import _ from 'lodash';
import store from 'src/store';
import { cartContainerConfig, initializeSettings, inventoryIconConfig, set_payment_terms, sync_ella_order_settings } from './setting';
import settings from 'src/utils/api_requests/setting';
import { INVENTORY_ICON_META } from 'src/common/@the-source/molecules/Inventory/constants';
import constants from 'src/utils/constants';
import buyer from 'src/utils/api_requests/buyer';
import country_config_settings from 'src/screens/CountryStateMap.json';
import { login, set_password, reset_password, get_user, logout_user, verifyTwoFa } from '../utils/api_requests/login';
import { replaceAuthUrlToHome } from 'src/utils/authUrl';
import { product_listing } from 'src/utils/api_requests/productListing';

const LOGIN_TWO_FACTOR_PATH = '/login/2fa';

const { PAYMENTS_KEY, WIZSHOP_KEY } = constants;

export const change_chatbot = (chatbot: any) => ({
	type: login_action_types.CHANGE_CHATBOT,
	chatbot,
});

export const reset_status = (status: boolean | null) => ({
	type: login_action_types.RESET_PASSWORD_SUCCESS,
	status,
});

export const change_email = (email: string) => ({
	type: login_action_types.CHANGE_EMAIL,
	email,
});

export const login_success = () => ({
	type: login_action_types.LOGIN_SUCCESS,
});
export const user_logout = () => ({
	type: USER_LOGOUT,
});
export const user_switch = () => ({
	type: USER_SWITCH,
});
export const change_status = (loggedIn: boolean) => ({
	type: login_action_types.CHANGE_STATUS,
	loggedIn,
});

const handle_show_label = (type: string, value: any, country_state_map: any, country_code: string, state_code?: string) => {
	switch (value?.label_key) {
		case 'alias':
			return value?.alias;

		default:
			if (type === 'country_single_select') {
				return country_state_map?.[country_code]?.[value?.label_key || 'name'];
			} else if (type === 'state_single_select' && state_code) {
				return country_state_map?.[country_code]?.states?.[state_code]?.[value?.label_key || 'name'];
			}
	}
};

const handle_get_country_state_map = (country_state_map: any) => {
	let all_countries_options = map(entries(country_state_map), ([country_code, country_value]: any) => {
		let display_value = handle_show_label('country_single_select', country_value, country_config_settings, country_code);
		return { label: display_value, value: country_code };
	});

	let all_states_options = _.mapValues(country_state_map, (country, country_code) => {
		const filtered = _.pickBy(country?.states, (state) => state?.is_display ?? true);
		return _.map(filtered, (state, state_code) => {
			let display_value = handle_show_label('state_single_select', state, country_config_settings, country_code, state_code);
			return {
				value: state_code,
				label: display_value,
			};
		});
	});

	let all_countries_map = _.mapValues(country_state_map, (country, country_code) => {
		let display_value = handle_show_label('country_single_select', country, country_config_settings, country_code);
		return { label: display_value, value: country_code };
	});

	let all_countries_states_map = fromPairs(
		flatMap(country_state_map, (country, country_code) =>
			map(country?.states, (state, state_code) => {
				let display_value = handle_show_label('state_single_select', state, country_config_settings, country_code, state_code);
				return [
					state_code,
					{
						value: state_code,
						label: display_value,
					},
				];
			}),
		),
	);

	return {
		all_countries_options,
		all_states_options,
		all_countries_map,
		all_countries_states_map,
	};
};

const handle_fetch_tenant_settings = async (dispatch: any) => {
	try {
		const [
			setting_response,
			subscription_response,
			payment_terms_response,
			display_priority,
			details_buyer_form,
			order_settings,
			quote_settings,
			document_filter_config,
			country_state_map_settings,
			inventory_response,
			ella_settings,
			// container_response,
			// inventory_response,
			// product_card_config,
			// all_card_configs,
			// cart_grouping_config,
			// default_ssrm_reposonse,
			// product_listing_config,
			// json_rule_payment_response,
			// json_rule_cart_calculations_response,
			// json_master_discount_rule_response,
			// document_line_item_config,
			// presentation_config,
			// line_item_meta_config,
			// response_nudges_config,
			// response_crm_settings,
			// task_filter_config,
			// lead_filter_config,
			// variant_ordering_config,
			// slots_response,
			// document_ssrm_expandable_config,
			// country_state_map_settings,
			// abandoned_cart_filter_config,
			// payment_charges_rule_response,
			// task_form,
			pim_groupping_rules,
		]: any = await Promise.all([
			settings.get_configuration('tenant_settings'),
			settings.get_subscription_info(),
			settings.get_payment_terms(1, 100),
			settings.get_default_tenant_config('display_priority'),
			buyer.get_main_buyer_details_form('create'),
			settings.get_document_settings('order'),
			settings.get_document_settings('quote'),
			settings.get_configuration('document_filter_config'),
			settings.get_configuration('country_state_display_map'),
			settings.get_inventory_icon(),
			settings.get_configuration('ella_order_settings'),
			// settings.get_containers_data(),
			// settings.get_inventory_icon(),
			// settings.get_product_card_config(),
			// settings.get_all_card_config(),
			// settings.get_configuration('cart_grouping_config'),
			// settings.get_default_tenant_config('default_ssrm_config'),
			// product_listing.get_listing_configuration('product_listing_page_config_web'),
			// settings.get_default_tenant_config('json_rule_payment_address'),
			// settings.get_default_tenant_config('json_rule_cart_calculations'),
			// settings.get_default_tenant_config('master_discount_rule'),
			// settings.get_configuration('document_line_item_config'),
			// settings.get_configuration('presentation_system_config'),
			// settings.get_default_tenant_config('line_item_meta_config'),
			// settings.get_default_tenant_config('nudges_settings'),
			// settings.get_default_tenant_config('crm_settings'),
			// settings.get_default_tenant_config('task_filter_config'),
			// settings.get_default_tenant_config('lead_filter_config'),
			// settings.get_configuration('variant_ordering_config'),
			// settings.get_configuration('slots_config'),
			// settings.get_configuration('document_ssrm_expandable_config'),
			// settings.get_configuration('country_state_display_map'),
			// settings.get_configuration('abandoned_cart_filter_config'),
			// settings.get_default_tenant_config('payment_charges_rule'),
			// settings.get_default_tenant_config('task_form'),
			// settings.get_payment_terms(1, 100),
			// settings.get_configuration('pim_groupping_rules'),
		]);

		let setting = {};

		let country_state_map_settings_data = handle_get_country_state_map(country_state_map_settings?.data);

		if (setting_response?.data) {
			setting = {
				...setting,
				subscription_info: subscription_response?.data,
				...setting_response?.data,
				// slots_config: slots_response?.data || [],
				is_tenant_settings_fetched: true,
				// nudges_config: response_nudges_config?.data,
				is_payments_enabled: !_.includes(setting_response?.data?.excluded_permission_modules, PAYMENTS_KEY),
				is_wizshop_enabled: !_.includes(setting_response?.data?.excluded_permission_modules, WIZSHOP_KEY),
				// product_card_config: product_card_config?.data,
				// all_cards_config: all_card_configs?.data,
				// default_ssrm_config: default_ssrm_reposonse?.data || {},
				// document_line_item_config: document_line_item_config?.data,
				// crm_settings: response_crm_settings?.data,
				// task_filter_config: task_filter_config?.data,
				// lead_filter_config: lead_filter_config?.data,
				// task_form: task_form ? task_form?.data : {},
				// document_ssrm_expandable_config: document_ssrm_expandable_config?.data,
				order_settings: order_settings?.sections,
				quote_settings: quote_settings?.sections,
				document_filter_config: document_filter_config?.data,
				country_state_map_settings: country_state_map_settings_data,
				ella_settings: ella_settings?.data,
				// abandoned_cart_filter_config: abandoned_cart_filter_config?.data,
				// pim_groupping_rules: pim_groupping_rules?.data,
			};
		}

		// if (container_response?.data?.tenant_container_enabled === true) {
		// 	dispatch(cartContainerConfig(container_response?.data));
		// } else {
		// 	dispatch(cartContainerConfig({ tenant_container_enabled: false }));
		// }

		if (inventory_response?.data) {
			dispatch(inventoryIconConfig(inventory_response?.data));
		} else {
			dispatch(inventoryIconConfig(INVENTORY_ICON_META));
		}

		// if (cart_grouping_config?.status_code === 200) {
		// 	setting = { ...setting, cart_grouping_config: cart_grouping_config?.data };
		// }

		// if (product_listing_config?.status_code === 200) {
		// 	const _rails = _.sortBy(product_listing_config?.data?.rails, 'priority');
		// 	setting = {
		// 		...setting,
		// 		product_listing_config: {
		// 			filters: product_listing_config?.data?.filters,
		// 			config: _rails,
		// 			sorts: product_listing_config?.data?.sorting,
		// 			search_in_config: product_listing_config?.data?.search_in_config,
		// 			global_sorts: product_listing_config?.data?.global_sorting,
		// 			default_filters: product_listing_config?.data?.default_filters,
		// 		},
		// 	};
		// }
		// if (presentation_config?.status_code === 200) {
		// 	setting = {
		// 		...setting,
		// 		presentation_config: presentation_config?.data,
		// 	};
		// }

		if (display_priority?.status_code === 200) {
			setting = { ...setting, display_priority: display_priority?.data };
		}

		// if (line_item_meta_config?.status_code === 200) {
		// 	setting = { ...setting, line_item_meta_config: line_item_meta_config?.data };
		// }

		if (details_buyer_form?.status_code === 200) {
			setting = { ...setting, details_buyer_form: details_buyer_form?.data };
		}
		// if (variant_ordering_config?.status_code === 200) {
		// 	setting = { ...setting, variant_ordering_config: variant_ordering_config?.data };
		// }
		// if (payment_charges_rule_response?.status_code === 200) {
		// 	setting = { ...setting, payment_charges_rule: payment_charges_rule_response?.data };
		// }

		if (payment_terms_response?.data) {
			setting = { ...setting, payment_terms: payment_terms_response?.data };
		}

		dispatch(initializeSettings(setting));

		if (ella_settings?.data) {
			dispatch(sync_ella_order_settings(ella_settings.data));
		}
	} catch (error) {
		console.error(error);
	}
};

export const show_login_toast = (dispatch: any, email: any) => {
	const handle_response_toast_close = () => {
		dispatch(close_toast(email));
	};

	const message = {
		open: true,
		showCross: false,
		anchorOrigin: {
			vertical: types.VERTICAL_TOP,
			horizontal: types.HORIZONTAL_CENTER,
		},
		autoHideDuration: 5000,
		onClose: handle_response_toast_close,
		state: types.SUCCESS_STATE,
		title: types.SUCCESS_TITLE,
		subtitle: i18next.t('AuthFlow.Login.Success'),
		showActions: false,
		id: 'log_in_toaster_success',
	};
	dispatch(show_toast(message));
};

export const handle_multi_tenant = async (dispatch: any, token: string) => {
	try {
		dispatch(save_persisted_data(PERSIST_REDUX_PATHS.temp_token, token));
		const response = await get_user(token);

		if (response.status === 200) {
			dispatch({
				type: login_action_types.STORE_USER_DETAILS,
				payload: response,
			});

			localStorage.setItem('all_tenants', JSON.stringify(response.all_tenants));
			localStorage.setItem('tenant_id', response.tenant_id);
		}
	} catch (e) {
		console.error(e);
	}
};

const finalize_auth_tokens = (
	dispatch: any,
	data: { token?: string; refresh_token?: string; is_tenant_selection_required?: boolean },
	email: string,
) => {
	const { token = '', refresh_token = '', is_tenant_selection_required = false } = data;
	if (is_tenant_selection_required) {
		handle_multi_tenant(dispatch, token);
	} else {
		dispatch(login_success());
		localStorage.setItem('logout-event', `logout${Math.random()}`);
		dispatch(save_persisted_data(PERSIST_REDUX_PATHS.auth_access_token, token));
		dispatch(save_persisted_data(PERSIST_REDUX_PATHS.auth_refresh_token, refresh_token));
		show_login_toast(dispatch, email);
	}
};

const TWO_FA_ERROR_SUBTITLE: Record<string, () => string> = {
	max_attempts_exceeded: () => i18next.t('AuthFlow.LoginTwoFactor.MaxAttemptsExceeded'),
	otp_expired: () => i18next.t('AuthFlow.LoginTwoFactor.OtpExpired'),
	invalid_token: () => i18next.t('AuthFlow.LoginTwoFactor.InvalidToken'),
	'2fa_not_applicable': () => i18next.t('AuthFlow.LoginTwoFactor.NotApplicable'),
};

const get2faErrorSubtitle = (
	errorKey: string | undefined,
	attemptsRemaining: number | undefined,
	serverMessage: string | undefined,
): string => {
	if (errorKey === 'invalid_otp' && typeof attemptsRemaining === 'number') {
		return attemptsRemaining === 0
			? i18next.t('AuthFlow.LoginTwoFactor.NoAttemptsRemaining')
			: i18next.t('AuthFlow.LoginTwoFactor.InvalidOtpAttempts', { count: attemptsRemaining });
	}

	const resolve = errorKey ? TWO_FA_ERROR_SUBTITLE[errorKey] : undefined;
	if (resolve) return resolve();
	if (serverMessage) return serverMessage;
	return i18next.t('AuthFlow.LoginTwoFactor.VerifyError');
};

const TWO_FA_RESEND_ERROR_SUBTITLE: Record<string, () => string> = {
	max_resends_exceeded: () => i18next.t('AuthFlow.LoginTwoFactor.MaxResendsExceeded'),
	otp_expired: () => i18next.t('AuthFlow.LoginTwoFactor.OtpExpired'),
	invalid_token: () => i18next.t('AuthFlow.LoginTwoFactor.InvalidToken'),
	'2fa_not_applicable': () => i18next.t('AuthFlow.LoginTwoFactor.NotApplicable'),
};

export const get2faResendErrorSubtitle = (errorKey: string | undefined, serverMessage: string | undefined): string => {
	const resolve = errorKey ? TWO_FA_RESEND_ERROR_SUBTITLE[errorKey] : undefined;
	if (resolve) return resolve();
	if (serverMessage) return serverMessage;
	return i18next.t('AuthFlow.LoginTwoFactor.ResendError');
};

const AUTH_FLOW_TOAST_DURATION_MS = 5000;

const AUTH_FLOW_TOAST_ANCHOR = {
	vertical: types.VERTICAL_TOP,
	horizontal: types.HORIZONTAL_CENTER,
} as const;

const createAuthFlowCloseToastHandler =
	(dispatch: any, toastKey: string) => (_event: React.SyntheticEvent<Element, Event>, reason: string) => {
		if (reason === types.REASON_CLICK) return;
		dispatch(close_toast(toastKey));
	};

const buildAuthFlowErrorToast = (subtitle: string, dispatch: any, toastKey: string) => ({
	open: true,
	showCross: false,
	anchorOrigin: AUTH_FLOW_TOAST_ANCHOR,
	autoHideDuration: AUTH_FLOW_TOAST_DURATION_MS,
	onClose: createAuthFlowCloseToastHandler(dispatch, toastKey),
	state: types.ERROR_STATE,
	title: types.ERROR_TITLE,
	subtitle,
	showActions: false,
});

/** Single place for `dispatch(show_toast(buildAuthFlowErrorToast(...)))` used by login + 2FA flows. */
export const dispatchAuthFlowErrorToast = (dispatch: any, toastKey: string, subtitle: string) =>
	dispatch(show_toast(buildAuthFlowErrorToast(subtitle, dispatch, toastKey)));

type LoginNavigateFn = (to: string, options?: { state?: unknown }) => void;

const tryNavigateToTwoFactor = (response: { status: number; data?: any }, navigate: LoginNavigateFn, email: string): boolean => {
	if (response.status !== 202) return false;
	const data = response.data;
	if (!data?.requires_2fa && !data?.is_2fa_required) return false;
	navigate(LOGIN_TWO_FACTOR_PATH, {
		state: {
			twoFaToken: data['2fa_token'],
			emailHint: data.email_hint,
			email,
			resendCooldownSeconds: typeof data.retry_after_seconds === 'number' ? data.retry_after_seconds : undefined,
		},
	});
	return true;
};

const trackLoginPageAuthFailure = (errorMessage: string, error: any, email: string | undefined) => {
	// Mixpanel.track(Events.LOGIN_FAILED, {
	// 	message: errorMessage,
	// 	status_code: error?.response?.status,
	// 	email,
	// 	page_name: 'login_page',
	// 	tab_name: '',
	// 	section_name: '',
	// });
};

const trackTwoFaPageAuthFailure = (message: string, error: any, email: string | undefined) => {
	// Mixpanel.track(Events.LOGIN_FAILED, {
	// 	message,
	// 	status_code: error?.response?.status,
	// 	email,
	// 	page_name: 'login_2fa_page',
	// 	tab_name: '',
	// 	section_name: '',
	// });
};

export const verify_two_factor_action =
	(payload: {
		twoFaToken: string;
		otp_code: string;
		email: string;
		set_loading: (loading: boolean) => void;
		set_otp_exhausted?: (exhausted: boolean) => void;
	}) =>
	async (dispatch: any) => {
		try {
			const response = await verifyTwoFa({ twoFaToken: payload.twoFaToken, otp_code: payload.otp_code });
			if (response.status === 200) {
				payload.set_loading(false);
				finalize_auth_tokens(dispatch, response.data, payload.email);
				// Auth unmounts and MainRouter mounts; reset URL and history state (do not keep old usr / 2FA state).
				replaceAuthUrlToHome();
			}
		} catch (error: any) {
			payload.set_loading(false);
			const errData = error?.response?.data;
			const errorKey = errData?.error;
			const attemptsRemaining = errData?.attempts_remaining;
			const otpExhausted = errorKey === 'max_attempts_exceeded' || (errorKey === 'invalid_otp' && attemptsRemaining === 0);
			payload.set_otp_exhausted?.(otpExhausted);

			const subtitle = get2faErrorSubtitle(errorKey, attemptsRemaining, errData?.message);
			dispatchAuthFlowErrorToast(dispatch, payload.email, subtitle);
			trackTwoFaPageAuthFailure(subtitle, error, payload?.email);
		}
	};

/** Load Ella /users/me visibility into Redux for app-wide sender allow-list checks. */
export const fetch_visibility_context = () => async (dispatch: any, getState: any) => {
	const user_details = getState()?.login?.userDetails;
	if (!user_details?.id) return;

	dispatch({ type: login_action_types.SET_VISIBILITY_LOADING, payload: true });
	try {
		const { load_visibility_context } = await import('src/utils/ellaUserAccess');
		const ctx = await load_visibility_context({
			wiz_order_is_admin: Boolean(user_details?.is_admin),
			own_email: user_details?.email || '',
		});
		dispatch({ type: login_action_types.STORE_VISIBILITY_CONTEXT, payload: ctx });
	} catch (error) {
		console.error('Failed to fetch visibility context', error);
		// Fail closed for members: own mailbox only
		const own_email = (user_details?.email || '').trim().toLowerCase();
		dispatch({
			type: login_action_types.STORE_VISIBILITY_CONTEXT,
			payload: {
				effective_role: user_details?.is_admin ? 'super_admin' : 'member',
				can_manage: Boolean(user_details?.is_admin),
				sender_emails: user_details?.is_admin ? null : own_email ? [own_email] : [],
				own_email,
				user_id: '',
				accesses: [],
			},
		});
	}
};

export const fetch_user_details = () => async (dispatch: any) => {
	try {
		const response = await get_user();
		if (response.status === 200) {
			dispatch({
				type: login_action_types.STORE_USER_DETAILS,
				payload: response,
			});

			Sentry.setUser({
				email: response?.email,
				id: response?.id,
			});
			dispatch(login_success());
			handle_fetch_tenant_settings(dispatch);
			// Ella visibility (/users/me + grants) for dashboard, notifications, draft gates
			dispatch({ type: login_action_types.SET_VISIBILITY_LOADING, payload: true });
			dispatch(fetch_visibility_context());
		}
	} catch (error) {
		localStorage.clear();
		sessionStorage.clear();
		localStorage.setItem('logout-event', `logout${Math.random()}`);
		dispatch(delete_persisted_data(PERSIST_REDUX_PATHS.auth_access_token));
		dispatch(user_logout());
		console.error('Error fetching user details:', error);
	}
};

export const login_action =
	(payload: { email: string; password: string; set_loading: any; navigate: (to: string, options?: { state?: unknown }) => void }) =>
	async (dispatch: any) => {
		const { email, password, set_loading, navigate } = payload;
		// const handle_close_toast = (_event: React.SyntheticEvent<Element, Event>, reason: string) => {
		// 	if (reason === types.REASON_CLICK) {
		// 		return;
		// 	}
		// 	dispatch(close_toast(email));
		// };

		if (email.length === 0 || password.length === 0) {
			set_loading(false);
			return dispatchAuthFlowErrorToast(dispatch, email, i18next.t('AuthFlow.Login.ErrorEmptyField'));
		}

		try {
			const response = await login({
				email,
				password,
				user_type: constants.LOGIN_USER_TYPE.SALES_REP,
			});
			set_loading(false);

			if (tryNavigateToTwoFactor(response, navigate, email)) {
				return;
			}

			finalize_auth_tokens(dispatch, response.data, email);
		} catch (error: any) {
			set_loading(false);
			const errorMessage = error?.response?.data?.message || i18next.t('AuthFlow.Login.ErrorInvalidCredentials');

			dispatchAuthFlowErrorToast(dispatch, email, errorMessage);
			console.error(error.error);
			trackLoginPageAuthFailure(errorMessage, error, email);
		}
	};

export const debounced_login_action = debounce((payload: any) => {
	return (dispatch: any) => {
		dispatch(login_action(payload));
	};
}, 1000);

export const forgot_password_action = (payload: any) => async (dispatch: any) => {
	try {
		await reset_password(payload);
		const handle_forgot_password_toast_close = () => {
			dispatch(close_toast(payload));
		};
		const message = {
			open: true,
			showCross: false,
			anchorOrigin: {
				vertical: types.VERTICAL_TOP,
				horizontal: types.HORIZONTAL_CENTER,
			},
			autoHideDuration: 5000,
			onClose: handle_forgot_password_toast_close,
			state: types.SUCCESS_STATE,
			title: types.SUCCESS_TITLE,
			subtitle: i18next.t('AuthFlow.ForgotPassword.Success'),
			showActions: false,
		};
		dispatch(show_toast(message));
	} catch (error: any) {
		const handle_debounced_login_action = (_event: React.SyntheticEvent<Element, Event>, reason: string) => {
			if (reason === types.REASON_CLICK) {
				return;
			}
			dispatch(close_toast(payload));
		};
		const message = {
			open: true,
			showCross: false,
			anchorOrigin: {
				vertical: types.VERTICAL_TOP,
				horizontal: types.HORIZONTAL_CENTER,
			},
			autoHideDuration: 5000,
			onClose: (event: React.SyntheticEvent<Element, Event>, reason: string) => handle_debounced_login_action(event, reason),
			state: types.ERROR_STATE,
			title: types.ERROR_TITLE,
			subtitle: error.error || i18next.t('AuthFlow.ResetPassword.ErrorUnableToReset'),
			showActions: false,
		};
		dispatch(show_toast(message));
		console.error(error);
	}
};

export const reset_password_action = (payload: any, uid: string, token: string) => async (dispatch: any) => {
	try {
		const response = await set_password(payload, uid, token);
		if (response?.status === 200) {
			const handle_reset_password_toast_close = () => {
				dispatch(close_toast(payload));
			};
			const message = {
				open: true,
				showCross: false,
				anchorOrigin: {
					vertical: types.VERTICAL_TOP,
					horizontal: types.HORIZONTAL_CENTER,
				},
				autoHideDuration: 5000,
				onClose: handle_reset_password_toast_close,
				state: types.SUCCESS_STATE,
				title: types.SUCCESS_TITLE,
				subtitle: i18next.t('AuthFlow.ResetPassword.Success'),
				showActions: false,
			};
			dispatch(show_toast(message));
			dispatch(reset_status(true));
		}
	} catch (error: any) {
		const handle_error_reset_password_toast_close = (_event: React.SyntheticEvent<Element, Event>, reason: string) => {
			if (reason === types.REASON_CLICK) {
				return;
			}
			dispatch(close_toast(payload));
		};
		const error_message =
			error?.response?.data?.error_code === 'USER__SAME_PREVIOUS_PASSWORD'
				? 'New Password cannot be same as the old'
				: error?.response?.data?.message;
		const message = {
			open: true,
			showCross: false,
			anchorOrigin: {
				vertical: types.VERTICAL_TOP,
				horizontal: types.HORIZONTAL_CENTER,
			},
			autoHideDuration: 5000,
			onClose: (event: React.SyntheticEvent<Element, Event>, reason: string) => handle_error_reset_password_toast_close(event, reason),
			state: types.ERROR_STATE,
			title: types.ERROR_TITLE,
			subtitle: error.error || error_message || i18next.t('AuthFlow.ResetPassword.ErrorUnableToReset'),
			showActions: false,
		};
		dispatch(show_toast(message));
		console.error(error);
	}
};

export const logout_click = () => async (dispatch: Dispatch) => {
	try {
		const token = _.get(store.getState(), 'persistedUserData.auth_access_token');
		logout_user({ token });
		dispatch(user_logout());
		dispatch(delete_persisted_data(PERSIST_REDUX_PATHS.auth_access_token));
		localStorage.clear();
		sessionStorage.clear();
		localStorage.setItem('logout-event', `logout${Math.random()}`);
	} catch (error) {
		console.log(error);
	}
};

export const forgot_password_email_action = (forgotPasswordEmail: string) => ({
	type: login_action_types.FORGOT_PASSWORD_CHANGE_EMAIL,
	forgotPasswordEmail,
});

export const set_wizpay_url = (url: string) => ({
	type: login_action_types.SET_WIZPAY_URL,
	payload: url,
});
